import { confirmColor, confirmBorderColor, cancelColor } from '../constants/Styles';
import { HorizontalButtonPairView } from '../components/DRViewUtils';
import { joinCommaSeparatedNames } from './utils/composeText';
import CornerGripperLogo from '../components/CornerGripperLogo';
import './ConfirmLoadScreen.scss';
import TimelineGraphic from '../components/TimelineGraphic';
import PinCodeReminder, { PinCodeData } from '../components/PinCodeReminder';
import { useState } from 'react';

interface ConfirmLoadScreenProps {
  requester: string;
  note: string;
  storageFilled: string[];
  pickups: string[];
  dropoffs: string[];
  currentStopIndex: number;
  clickCancel: () => void;
  clickConfirm: () => void;
  tapToReload: () => void;
  hideDetails: boolean;
  isRestricted: boolean;
  codeRequired?: boolean;
  pinCodeData?: PinCodeData[];
}

export default function ConfirmLoadScreen(props: ConfirmLoadScreenProps) {
  const {
    requester,
    note,
    storageFilled,
    pickups,
    dropoffs,
    currentStopIndex,
    clickCancel,
    clickConfirm,
    tapToReload,
    hideDetails,
    isRestricted,
    codeRequired,
    pinCodeData,
  } = props;
  const [showPinCodeReminder, setShowPinCodeReminder] = useState(false);
  const buttonSettings = [
    {
      phrase: 'GO BACK',
      fillColor: 'transparent',
      borderColor: cancelColor,
      fontColor: cancelColor,
      action: clickCancel,
    },
    {
      phrase: 'CONFIRM',
      fillColor: confirmColor,
      borderColor: confirmBorderColor,
      fontColor: 'white',
      action: clickConfirm,
    },
  ];

  const renderPinCodeReminder = () => {
    if (codeRequired && pinCodeData && pinCodeData.length > 0)
      return (
        <button className="pin-code-reminder__icon" onClick={() => setShowPinCodeReminder(true)}>
          i
        </button>
      );
    return null;
  };

  return (
    <div className="confirm-load-screen">
      <CornerGripperLogo tapToReload={tapToReload} />
      {renderPinCodeReminder()}
      <div className="confirm-load-screen__content">
        <div className="content__title">
          {hideDetails ? (
            <span className="content__title-text">Confirm delivery?</span>
          ) : (
            <span className="content__title-text">
              Confirm{' '}
              {isRestricted ? (
                <span className="content__title-text--emph">{codeRequired ? 'multi-factor' : 'restricted'}&nbsp;</span>
              ) : (
                ''
              )}
              delivery to <span className="content__title-text--emph">{joinCommaSeparatedNames(dropoffs)}</span>
            </span>
          )}
        </div>
        <div className="content__subtitle">
          <span className="content__subtitle-text">{`${joinCommaSeparatedNames(storageFilled)} Drawer`}</span>
        </div>
        <div
          className={`content__details ${
            note === '' ? 'content__details--center-align' : 'content__details--left-align'
          }`}
        >
          {note === '' ? (
            <span className="details__text details__text--gray">No notes</span>
          ) : (
            <div>
              <div className="details__label">
                <span className="details__label-text">Notes</span>
                <div className="details__label-line" />
              </div>
              <span className="details__text details__text--black">{note}</span>
            </div>
          )}
        </div>
        {!hideDetails && (
          <div className="content__graphic">
            <TimelineGraphic
              requester={requester}
              pickups={pickups}
              dropoffs={dropoffs}
              currentStopIndex={currentStopIndex}
            />
          </div>
        )}
      </div>
      <div className="confirm-load-screen__footer">
        <HorizontalButtonPairView buttonSettings={buttonSettings} />
      </div>
      {showPinCodeReminder && pinCodeData && (
        <PinCodeReminder clickOkay={() => setShowPinCodeReminder(false)} pinCodeData={pinCodeData} />
      )}
    </div>
  );
}

ConfirmLoadScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
ConfirmLoadScreen.viewName = 'ConfirmLoadScreen';
